import { render, staticRenderFns } from "./CommentsPost.vue?vue&type=template&id=490885b8&scoped=true"
import script from "./CommentsPost.vue?vue&type=script&lang=js"
export * from "./CommentsPost.vue?vue&type=script&lang=js"
import style0 from "./CommentsPost.vue?vue&type=style&index=0&id=490885b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490885b8",
  null
  
)

export default component.exports